import { OrganisationConnection } from "@/types/organisatio";
import { Customer } from "../types";
import { OrganisationWithLicencesResponse } from "@/types/licenceSolutions";

export const transformOrganisationsToCustomers = (
  organisations: OrganisationWithLicencesResponse[],
  connections: OrganisationConnection[],
): Customer[] => {
  const connectionsDictionary = connections.reduce(
    (acc: Record<string, OrganisationConnection>, cur) => {
      acc[cur.organisation_uuid] = cur;
      return acc;
    },
    {},
  );

  return organisations.map((organisation) => ({
    uuid: organisation.uuid,
    name: organisation.name,
    description: organisation.description ?? "",
    seats_used: organisation.licence?.seats_used ?? 0,
    seats_purchased: organisation.licence?.seats_purchased ?? 0,
    created_at: organisation.created_at,
    hasConnection: connectionsDictionary[organisation.uuid]?.connected,
    isLegacy: connectionsDictionary[organisation.uuid]?.legacy ?? false,
  }));
};
